const draggedElementsIds = new Set()

export default draggedElementsIds
